module.exports = __webpack_public_path__ + "img/mic-on.63e880e1.svg";